<script>
    import { Navigate } from "svelte-router-spa";

    export let showLogin = true;
    export let showSupport = false;
</script>
<nav class="navbar navbar-expand-lg" id="navbar" style="padding: 10px 0 !important;">
    <div class="container">
        <a class="navbar-brand">
            <div>
                <img src="/images/tamseel_logo.png" alt="Logo" style="width: 45px;">
                <span style="color: white; margin-left: 10px;">Tamseel</span>
            </div>
        </a>
        <div>
            <ul class="navbar-nav mr-auto">
                <li></li>
            </ul>

            <div class="d-flex">
                {#if showLogin}
                <div>
                    <Navigate to="/login">
                        <button class="btn btn-primary">
                            Login
                        </button>
                    </Navigate>
                </div>
            {/if}

            {#if showSupport}
                <div class="ml-2">
                    <Navigate to="/support">
                        <button class="btn btn-primary">
                            Contact
                        </button>
                    </Navigate>
                </div>
            {/if}
            </div>
        </div>
    </div>
</nav>